import * as React from 'react'
import { PaymentResultView } from '@modules/payment-result/index'
import { OperationResult } from '@modules/payment-result/utils'

export const PaymentSuccessView = (): JSX.Element => <PaymentResultView operationResult={OperationResult.success} />
